import React from "react"
import {
  RadioGroup as MUIRadioGroup,
  RadioGroupProps as MUIRadioGroupProps,
} from "@mui/material"
import { MUIMappedRadioGroup } from "./mantine/RadioGroup.mantine"

export type RadioGroupProps =
  | ({ new?: false } & MUIRadioGroupProps)
  | ({ new: true } & MUIRadioGroupProps)

export const RadioGroup = React.forwardRef<any, RadioGroupProps>((props, ref) =>
  props.new ? (
    <MUIMappedRadioGroup {...props} ref={ref} />
  ) : (
    <MUIRadioGroup {...props} ref={ref} />
  ),
)

RadioGroup.displayName = "RadioGroup"

export default RadioGroup
